import "../css/style.scss";

// Our modules / classes
// import MobileMenu from "./modules/MobileMenu";
// import HeroSlider from "./modules/HeroSlider";
//import GoogleMap from "./modules/GoogleMap";
import Search2 from "./modules/Search2";
import Search_foretag from "./modules/Search_foretag";
import Search_inside_foretag_ledigajobb from "./modules/Search_inside_foretag_ledigajobb";
import Search_inside_fixedplats_ledigajobb from "./modules/Search_inside_fixedplats_ledigajobb";
// Instantiate a new object using our modules/classes
//const mobileMenu = new MobileMenu();
// const heroSlider = new HeroSlider();
//const googleMap = new GoogleMap();
const search = new Search2();
const search_foretag = new Search_foretag();
const search_inside_foretag_ledigajobb = new Search_inside_foretag_ledigajobb();
const search_inside_fixedplats_ledigajobb =
  new Search_inside_fixedplats_ledigajobb();
